import { useState } from 'react';
import { Link } from 'react-router-dom';
import './PartnersGrid.css';

interface Partner {
  id: number;
  name: string;
  logo: string;
  website: string;
}

const PartnersGrid = () => {
  const [imageErrors, setImageErrors] = useState<Record<number, boolean>>({});

  const partners: Partner[] = [
    {
      id: 1,
      name: 'Matogu Foundation',
      logo: '/partner/matogu.png',
      website: '#'
    },
    {
      id: 2,
      name: 'South Africa Police Service (SAPS)',
      logo: '/partner/saps.jpg',
      website: 'https://www.saps.gov.za/'
    },
    {
      id: 3,
      name: 'Mediclinic South Africa',
      logo: '/partner/medi.png',
      website: 'https://www.mediclinic.co.za/'
    },
    {
      id: 4,
      name: 'Department of Social Development (DSD)',
      logo: '/partner/dsd.png',
      website: 'https://www.dsd.gov.za/'
    },
    {
      id: 5,
      name: 'Government Public Employment Programme',
      logo: '/partner/epwp.jpg',
      website: 'https://www.epwp.gov.za/'
    },
    {
      id: 6,
      name: 'Forward Food SA',
      logo: '/partner/foodforward.png',
      website: 'https://foodforwardsa.org/'
    }
  ];

  const filteredPartners = partners;

  const handleImageError = (id: number) => {
    setImageErrors(prev => ({ ...prev, [id]: true }));
  };

  return (
    <div className="partners-grid-container">
      {filteredPartners.length > 0 ? (
        <div className="partners-grid">
          {filteredPartners.map(partner => (
            <div key={partner.id} className="partner-card">
              <div className="partner-logo-container">
                <img 
                  src={imageErrors[partner.id] ? '/partner/default-logo.jpg' : partner.logo} 
                  alt={`${partner.name} logo`} 
                  className="partner-logo"
                  onError={() => handleImageError(partner.id)}
                  loading="lazy"
                />
              </div>
              <div className="partner-info">
                <h3 className="partner-name">{partner.name}</h3>
              </div>
              <a 
                href={partner.website} 
                target="_blank" 
                rel="noopener noreferrer"
                className="partner-link"
                aria-label={`Visit ${partner.name} website`}
              >
                <span>Visit Website</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-results">
          <p>No partners available at the moment.</p>
        </div>
      )}

      <div className="partner-cta">
        <p>Interested in becoming a partner?</p>
        <Link to="/contact" className="btn btn-primary" onClick={() => window.scrollTo(0, 0)}>
          Contact Us
        </Link>
      </div>
    </div>
  );
};

export default PartnersGrid;
